import { Box, Typography, Divider } from '@mui/material';

const MessageTemplateHelp: React.FC = () => {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
        Message Template Placeholders
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
        Placeholders are special tags that will be replaced with actual data when the message is sent. Use curly braces to wrap the placeholder name.
      </Typography>
      <Divider sx={{ my: 1.5 }} />
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        Available Placeholders:
      </Typography>
      <Box component="ul" sx={{ pl: 2, mb: 2, '& li': { mb: 0.5 } }}>
        <li>
          <code>{'{guestName}'}</code> - Guest's full name
        </li>
        <li>
          <code>{'{reservationId}'}</code> - Reservation ID
        </li>
        <li>
          <code>{'{arrivalDate}'}</code> - Check-in date
        </li>
        <li>
          <code>{'{departureDate}'}</code> - Check-out date
        </li>
        <li>
          <code>{'{conceptName}'}</code> - Concept/Hotel name
        </li>
        <li>
          <code>{'{confirmationNumber}'}</code> - Confirmation number
        </li>
        <li>
          <code>{'{status}'}</code> - Reservation status
        </li>
      </Box>
      <Divider sx={{ my: 1.5 }} />
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        Example:
      </Typography>
      <Box sx={{ mb: 1, p: 1.5, bgcolor: 'grey.100', borderRadius: 1 }}>
        <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
          Input:
        </Typography>
        <Typography variant="body2" component="pre" sx={{ m: 0, fontFamily: 'monospace', fontSize: '0.875rem' }}>
          Hi {`{guestName}`}, your reservation {`{reservationId}`} is confirmed. Check-in: {`{arrivalDate}`}
        </Typography>
      </Box>
      <Box sx={{ p: 1.5, bgcolor: 'success.light', borderRadius: 1 }}>
        <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
          Output:
        </Typography>
        <Typography variant="body2" component="pre" sx={{ m: 0, fontFamily: 'monospace', fontSize: '0.875rem' }}>
          Hi John Doe, your reservation 12345 is confirmed. Check-in: 2025-01-15
        </Typography>
      </Box>
    </Box>
  );
};

export default MessageTemplateHelp;

